export default "__VITE_ASSET__DRmT29uV__"